import { QueryClientProvider } from "@tanstack/react-query";

import { useCbhQueryClient } from "./queryClient";

interface QueryProviderProps {
  children: React.ReactNode;
}

export function CbhQueryClientProvider(props: QueryProviderProps) {
  const cbhQueryClient = useCbhQueryClient();

  return <QueryClientProvider client={cbhQueryClient}>{props.children}</QueryClientProvider>;
}
